import * as React from 'react';
import { Query } from 'react-apollo';

import ACCOUNT_NAVIGATION_QUERY from 'user/queries/AccountNavigationQuery.gql';
import Icon from 'components/Icon';
import Link from 'components/Link';
import MediaObject from 'components/MediaObject';
import Menu from 'components/Menu';
import MenuButton from 'components/MenuButton';
import MenuItem from 'components/MenuItem';
import NavigationListCreateGroupAction from 'components/NavigationList/NavigationListCreateGroupAction';
import NavigationListJoinGroupAction from 'components/NavigationList/NavigationListJoinGroupAction';
import TextWithIcon from 'components/TextWithIcon';
// @ts-ignore
import TriggerComposerButton from 'chat/components/TriggerComposerButton';
import UserNavigationMenu from 'components/UserNavigationMenu';

import { AccountNavigationQuery as AccountNavigationQueryData } from 'user/queries/__generated__/AccountNavigationQuery';

import './styles/AccountNavigation.scss';

type Props = {
  data: AccountNavigationQueryData | undefined;
};

function AccountNavigation(props: Props) {
  const user = props.data?.user;
  const name = user ? user.display_name : '_ _ _';
  const isAdminOfPaidOrg = !!user?.organizations?.length;

  return (
    <div className="AccountNavigation">
      <UserNavigationMenu isAdminOfPaidOrg={isAdminOfPaidOrg}>
        <div className="AccountNavigation-name">
          <Link color="inherit">
            <MediaObject figure="right" center>
              <TextWithIcon center size="xsmall" iconSize="medium" icon="">
                {name}
              </TextWithIcon>
              <Icon name="chevron-down" size="small" />
            </MediaObject>
          </Link>
        </div>
      </UserNavigationMenu>
      <div className="AccountNavigation-actions">
        <div className="AccountNavigation-actions-item">
          <TriggerComposerButton
            data-test="trigger-composer-button"
            level="text"
            color="pitch"
            size="xxsmall"
            full
            label={
              <MediaObject figure="right" center>
                <TextWithIcon
                  center
                  size="xsmall"
                  iconSize="medium"
                  icon="pencil-compose-stroke"
                  iconColor="pitch"
                  color="pitch">
                  New message
                </TextWithIcon>
                <Icon
                  name="chevron-down"
                  size="small"
                  color="pitch"
                  className="AccountNavigation-actions-item-chevron"
                />
              </MediaObject>
            }
          />
        </div>
        <div className="AccountNavigation-actions-item">
          <MenuButton
            data-test="add-a-group-button"
            level="text"
            color="pitch"
            size="xxsmall"
            full
            menu={
              <Menu rowHover>
                <MenuItem menuKey="join-group">
                  <NavigationListJoinGroupAction />
                </MenuItem>
                <MenuItem menuKey="create-group">
                  <NavigationListCreateGroupAction />
                </MenuItem>
              </Menu>
            }>
            <MediaObject figure="right" center>
              <TextWithIcon
                center
                size="xsmall"
                iconSize="medium"
                icon="plus-circle"
                iconColor="pitch"
                color="pitch">
                Add group
              </TextWithIcon>
              <Icon
                name="chevron-down"
                size="small"
                color="pitch"
                className="AccountNavigation-actions-item-chevron"
              />
            </MediaObject>
          </MenuButton>
        </div>
      </div>
    </div>
  );
}

function WrappedComponent() {
  return (
    <Query<AccountNavigationQueryData> query={ACCOUNT_NAVIGATION_QUERY}>
      {({ data }) => <AccountNavigation data={data} />}
    </Query>
  );
}
export { AccountNavigation };
export default WrappedComponent;
